import styled from 'styled-components';

export const Container = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
`;
